module.exports = {
  apiPrefix: 'https://www.corriere.it',
  build: {
    entryPublicPath: 'https://components2.corriereobjects.it'
  },
  externals: [
    {
      var: 'LazyLoad',
      src:
        'https://cdnjs.cloudflare.com/ajax/libs/vanilla-lazyload/10.5.2/lazyload.min.js'
    }
  ]
};



// WEBPACK FOOTER //
// ./config/config.prod.js